'use strict';

angular.module('atex.dam').directive('damMarkAsSpinner',
  function() {
    return {
      scope: false,
      link: function(scope, element, attrs) {

        var opts = {
          lines:   5, 
          length:  4, 
          width:   4, 
          radius:  2, 
          corners: 1, 
          rotate:  0, 
          direction: 1, 
          color: '#aaa', 
          speed: 1, 
          trail: 60, 
          shadow:  false, 
          hwaccel: false, 
          className: 'spinner', 
          zIndex: 100, 
          top:  'auto', 
          left: 'auto' 
        };

        var spinner = new Spinner(opts).spin();
        element.append(spinner.el);
      }
    };
  }
);
